import { chain, flatten, reject } from 'ramda';

const getEntriesFromDirectory = async (directory, errors, promises) => {
  return await new Promise((resolve, reject) => {
    const reader = directory.createReader();
    const result = [];
    const doBatch = () =>
      reader.readEntries(async (entries) => {
        if (entries.length > 0) {
          for (const entry of entries) {
            if (entry.isDirectory) {
              result.push(entry);
              try {
                await getEntriesFromDirectory(entry, errors, promises);
              } catch (e) {
                errors.push({
                  name: entry.name,
                  path: entry.fullPath
                })
              }
            } else {
              result.push(entry)
              promises.push(entry);
            }
          }
          doBatch();
        } else {
          if (result.length == 0) {
            promises.push(directory)
            resolve([directory])
          } else {
            resolve(
              result
            )
          }
          /* resolve(
            result
          ) */
        }
      }, reject
      );
    doBatch();
  })
};

const getItems = async (files, promises, errors) => {
  for (let item of files) {
    if (item.isFile) {
      promises.push(item);
    } else if (item.isDirectory) {
      const prom = await getEntriesFromDirectory(item, errors, promises);
    }
  }
  return;
}

const getEntriesFromFiles = async (files, errors) => {
  const promises = [];
  const dta = [...files].map(it => it.webkitGetAsEntry())
  await getItems(dta, promises, errors);
  return promises;
}

export default getEntriesFromFiles;
